import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../images/bannerf.jpeg";
import Header from "../../component/mainAdmin/Header";
import SideBar from "../../component/mainAdmin/SideBar";
import Banner from "../../component/mainAdmin/Banner";
import Banner1 from "../../component/mainAdmin/Banner1";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewCourseData,
  emptyMessage,
} from "../../Redux/action/courseAction/index";
import Modal from "react-awesome-modal";
import Logos from "../../images/landscape_logo.png";
import NewSideBar from "../../component/mainAdminComponents/newSideBar";
import ContentEditable from "react-contenteditable";
import { getAllCourseList } from "../../Redux/action/courseList";

const AddCourse = () => {
  const dispatch = useDispatch();
  const { message, loading } = useSelector((state) => state.courseReducer);
  const [chkState,setchkState] = useState('')
  const [instrucone,setinstrucone] = useState('Colour print your downloaded pdf file and bring it to Sir Adamjee Institute, Federal B Area Block 2 Gulberg Town, KHI.')
  const [instructwo,setinstructwo] = useState('Come along with fees i.e.  and which is complete fees of 4 months module.')
  const [instructhree,setinstructhree] = useState('Orientation class will be on 13th March 2022, Sunday from 3:00pm to 5:00pm')
  const [instrucfour,setinstrucfour] = useState('We have very limited seats available so come in between 5pm to 9pm (Mon to Sat) to submit fees')

  const handleinstructionschange = (e,setstate) => {
     setstate(e.target.value)
     setState({...state,instructions:[instrucone,instructwo,instructhree,instrucfour]})
  }

  const refone = React.useRef(null);
  const reftwo = React.useRef(null);
  const refthree = React.useRef(null);
  const reffour = React.useRef(null);

  const [cityList, setCityList] = useState([
    {
      label: "Select City",
      code: "",
    },
    {
      label: "Karachi",
      code: "K",
    },
    {
      label: "Faisalabad",
      code: "F",
    },
    {
      label: "Islamabad",
      code: "I",
    },
    {
      label: "Hyderabad",
      code: "H",
    },
    {
      label: "Lahore",
      code: "L",
    },
    {
      label: "Quetta",
      code: "Q",
    },
  ]);
  const [instituteList, setInstituteList] = useState([
    {
      label: "Select Institute",
      code: "",
    },
    {
      label: "BMJ Digital Education",
      code: "BJ",
    },
    {
      label: "SAIMS ( WOW )",
      code: "WOW",
    },
    {
      label:"OMYS Academy",
      code:"OMYS"
    },
    {
      label:"Jawan Pakistan Academy",
      code:"JPA"
    },
    {
      label:"Online Training",
      code:"JPOT"
    },
  ]);
  const [modalVisible, setModalVisible] = useState(false);

  const {courseList} = useSelector(state => state.courseListReducer)

  const maincourselist = [{
    courseName: "Select Course",
    courseCode: "",
  },,...courseList]


  // const [courseList, setCourseList] = useState([
  //   {
  //     label: "Select Course",
  //     code: "",
  //   },
  //   {
  //     label: "Web and Mobile App Dev",
  //     code: "WM",
  //   },
  //   {
  //     label: "Mobile App Dev Using Flutter",
  //     code: "FL",
  //   },
  //   {
  //     label: "Graphic Designing",
  //     code: "GD",
  //   },
  //   {
  //     label: "IT Essential",
  //     code: "IE",
  //   },
  //   {
  //     label: "Textile Training",
  //     code: "TT",
  //   },
  //   {
  //     label: "Certified Computerized Accountancy",
  //     code: "CA",
  //   },
  //   {
  //     label: "Cyber Security",
  //     code: "CS",
  //   },
  //   {
  //     label: "Mobile Repairing",
  //     code: "MR",
  //   },
  //   {
  //     label: "CCNA",
  //     code: "CNA",
  //   },
  //   {
  //     label: "Video Editing",
  //     code: "VE",
  //   },

  //   {
  //     label: "Network Essential",
  //     code: "NE",
  //   },
  //   {
  //     label: "Microsoft Office Specialist",
  //     code: "MS",
  //   },
  //   {
  //     label: "CCO",
  //     code: "CO",
  //   },
  //   {
  //     label: "Artificial Intellegence",
  //     code: "AI",
  //   },
  //   {
  //     label: "Cloud Native",
  //     code: "CN",
  //   },
  //   {
  //     label: "Internet of things",
  //     code: "IT",
  //   },
  //   {
  //     label: "Blockchain technology",
  //     code: "BT",
  //   },
  //   {
  //     label: "Digital Marketing",
  //     code: "DM",
  //   },
  //   {
  //     label: "Robotics",
  //     code: "RS",
  //   },
  //   {
  //     label: "Database Administration",
  //     code: "DA",
  //   },
  // ]);
  const [state, setState] = useState({
    city: "",
    course: "",
    institute: "",

    batch: "",
    lastDate: "",
    courseDura: "",
    courseStatus: "",
    courseId: "",
    instituteCode: "",
    courseSlot: "",
    courseSlots: [],
    instruction: "",
    instructions: [instrucone,instructwo,instructhree,instrucfour],
    year: "",
    cityCode: "",
    price: "",
    cardExpiry: "",
    chkPrice: false,
    chkcardExpiry: false,
    chkCity: false,
    chkInstitute: false,
    chkCourse: false,
    chkBatch: false,
    chkLastDate: false,
    chkCourseStatus: false,
    chkCourseDura: false,
    chkCourseSlot: false,
    chkInstruction: false,
  });

  console.log(state.city,)

  const setData = (e, a, b, c, d) => {
    setState({ ...state, [a]: d[e]["label"], [b]: d[e]["code"], [c]: false });
  };
  const setDataCourseList = (e, a, b, c, d) => {
    setState({ ...state, [a]: d[e]["courseName"], [b]: d[e]["courseCode"], [c]: false });
  };



    useEffect(() => {
        dispatch(getAllCourseList())
    },[])

  const addCourseSlots = () => {
    setState({
      ...state,
      courseSlots: [...state.courseSlots, state.courseSlot],
      courseSlot: "",
    });
  };
  const addInstructions = () => {
    setState({
      ...state,
      instructions: [...state.instructions, state.instruction],
      instruction: "",
    });
  };

  const addNewCourse = () => {
    const {
      city,
      cityCode,
      course,
      courseId,
      batch,
      lastDate,
      courseDura,
      courseStatus,
      institute,
      instituteCode,
      courseSlots,
      instructions,
      price,
      cardExpiry,
    } = state;

    console.log(course,'cccccc')

    if (!city || city == "Select City") {
      setState({ ...state, chkCity: true });
    } else if (!institute || institute == "Select Institute") {
      setState({ ...state, chkInstitute: true });
    } else if (!course || course == "Select Course") {
      setState({ ...state, chkCourse: true });
    } else if (!batch) {
      setState({ ...state, chkBatch: true });
    } else if (!lastDate) {
      setState({ ...state, chkLastDate: true });
    } else if (!courseSlots || courseSlots.length == 0) {
      setState({ ...state, chkCourseSlot: true });
    } else if (!instructions || instructions.length == 0) {
      setState({ ...state, chkInstruction: true });
    } else if (!courseDura) {
      setState({ ...state, chkCourseDura: true });
    } else if (!price) {
      setState({ ...state, chkPrice: true });
    } else if (!cardExpiry) {
      setState({ ...state, chkcardExpiry: true });
    } else if (!courseStatus) {
      setState({ ...state, chkCourseStatus: true });
    } else {
    //  setState({...state,instructions:[instrucone,instructwo,instructhree,instrucfour]})
    setState({...state,instructions:[instrucone,instructwo,instructhree,instrucfour]})
      console.log('done');
      dispatch(
        addNewCourseData(
          city,
          cityCode,
          course,
          courseId,
          batch,
          institute,
          instituteCode,
          lastDate,
          courseDura,
          courseStatus,
          courseSlots,
          instructions,
          price,
          cardExpiry
        )
      );
    }
  };

  useEffect(() => {
    // console.log(loading, message);
    if (message == "Course Annoucement Added succesfully") {
      openModal();
      setTimeout(() => {
        dispatch(emptyMessage());
      }, 3000);
      setState({
        ...state,
        city: "",
        batch: "",
        institute: "",
        course: "",
        lastDate: "",
        courseSlot: "",
        courseSlots: [],
        instruction: "",
        instructions: [],
        courseDura: "Select Month",
        courseStatus: false,
      });
    } else if (message == "Course Not Annoucement Added succesfully") {
      openModal();
      setTimeout(() => {
        dispatch(emptyMessage());
      }, 3000);
    } else if (message == "") {
      closeModal();
    }
  }, [loading, message]);

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Header />
      <div className="banner-img1">{/* <Banner1 /> */}</div>
      {/* Main Container */}
      <div className="sidebar-banner-container" style={{ display: "flex" }}>
        <NewSideBar />

        <div className="container-fluid">
          <Modal
            visible={modalVisible}
            width="400"
            height="200"
            effect="fadeInUp"
            onClickAway={() => closeModal()}
          >
            <div className="p-2">
              <div className="row mt-1">
                <img
                  src={Logos}
                  style={{ width: 200, height: 50, marginLeft: 100 }}
                />
              </div>
              <p className="font-weight-bold mt-5"> Note: {message}</p>
              <a
                className="btn btn-danger"
                style={{ position: "absolute", right: 10, bottom: 10 }}
                href="javascript:void(0);"
                onClick={() => closeModal()}
              >
                Close
              </a>
            </div>
          </Modal>

          <div className="row justify-content-center">
            <div className="col-md-8 p-5 text-white text-center">
              <h1 className="color title fs-2">Open New Course Admissions</h1>
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Select City</p>
              <select
                className="inp "
                onChange={(e) => {
                  setData(
                    e.target.value,
                    "city",
                    "cityCode",
                    "chkCity",
                    cityList
                  );
                }}
                //   value={state.city}
              >
                {cityList.map((e, i) => {
                  return (
                    <option key={i} value={i}>
                      {e.label.charAt(0).toUpperCase() + e.label.slice(1)}
                    </option>
                  );
                })}
              </select>
              {state.chkCity ? (
                <p className="text-danger">Select City</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Select Institute</p>
              <select
                className="inp"
                onChange={(e) => {
                  setData(
                    e.target.value,
                    "institute",
                    "instituteCode",
                    "chkInstitute",
                    instituteList
                  );
                }}
                //  value={state.institute}
              >
                {instituteList.map((e, i) => {
                  return (
                    <option key={i} value={i}>
                      {e.label.charAt(0).toUpperCase() + e.label.slice(1)}
                    </option>
                  );
                })}
              </select>
              {state.chkInstitute ? (
                <p className="text-danger">Select Institute</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Select Course</p>
              <select
                className="inp"
                onChange={(e) => {
                  setDataCourseList(
                    e.target.value,
                    "course",
                    "courseId",
                    "chkCourse",
                    maincourselist
                  );
                }}
              >
                {maincourselist.map((e, i) => {
                  return (
                    <option key={i} value={i}>
                      {e.courseName.charAt(0).toUpperCase() + e.courseName.slice(1)}
                    </option>
                  );
                })}
              </select>
              {state.chkCourse ? (
                <p className="text-danger">Select Course</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Enter Course Fees</p>
              <input
                type="number"
                // value={batch}
                className="inp"
                placeholder="Enter Course Fees"
                onChange={(e) => {
                  setState({
                    ...state,
                    price: e.target.value,
                    chkPrice: false,
                  });
                }}
              />
              {state.chkPrice ? (
                <p className="text-danger">Enter Course Fees</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Enter Card Expiry</p>
              <input
                // value={batch}
                className="inp"
                placeholder="Enter Card Expiry"
                onChange={(e) => {
                  setState({
                    ...state,
                    cardExpiry: e.target.value,
                    chkcardExpiry: false,
                  });
                }}
              />
              {state.chkcardExpiry ? (
                <p className="text-danger">Enter Card Expiry</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3">
              <p className="color title">Enter Batch Number</p>
              <input
                type="number"
                // value={batch}
                className="inp"
                placeholder="Enter Batch Number 01"
                onChange={(e) => {
                  setState({
                    ...state,
                    batch: e.target.value,
                    chkBatch: false,
                  });
                }}
              />
              {state.chkBatch ? (
                <p className="text-danger">Enter Batch No Like 01</p>
              ) : null}
            </div>

            <div className="col-md-5 py-3 mr-1">
              <p className="color title">Last Date of Admission</p>
              <input
                type="date"
                //   value={lastDate}
                className="inp"
                placeholder="Enter Batch Number"
                onChange={(e) => {
                  setState({
                    ...state,
                    lastDate: e.target.value,
                    chkLastDate: false,
                  });
                }}
              />
              {state.chkLastDate ? (
                <p className="text-danger">Enter Date</p>
              ) : null}
            </div>
            <div className="col-md-5 py-3 mr-3 row">
              <div className="col-md-10">
                <p className="color title">Course Slots</p>
                <input
                  type="text"
                  value={state.courseSlot}
                  className="inp"
                  placeholder="Enter Course Slots"
                  onChange={(e) => {
                    setState({
                      ...state,
                      courseSlot: e.target.value,
                      chkCourseSlot: false,
                    });
                  }}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    addCourseSlots();
                  }}
                  style={{ width: 80, height: 48, marginTop: 45 }}
                >
                  Add
                </button>
              </div>
              {state.chkCourseSlot ? (
                <p className="text-danger">Enter Course Slot</p>
              ) : null}
            </div>
            <div className="col-md-10">
              {state.courseSlots.length > 0 ? (
                <p className="color title">Course Slot List</p>
              ) : null}
              <div className="row ml-3">
                {state.courseSlots.map((val, ind) => {
                  return (
                    <span key={ind} className="row" style={{ marginRight: 10 }}>
                      <li className="mr-2 mt-3">
                        {ind + 1}) {val}
                      </li>
                      <i
                        onClick={() => {
                          state.courseSlots.splice(ind, 1);
                          setState({
                            ...state,
                            courseSlots: [...state.courseSlots],
                          });
                        }}
                        className="fa fa-times mr-4 mt-3"
                        style={{
                          color: "white",
                          fontSize: 13,
                          backgroundColor: "red",
                          borderRadius: 50,
                          width: "17px",
                          height: "17px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  );
                })}
              </div>
            </div>
            <div className="col-md-12 py-3">
              <div className="row justify-content-center">
                <div className="col-md-5">
                  <p className="color title">Course Duration</p>
                  <select
                    className="inp"
                    onChange={(e) => {
                      setState({
                        ...state,
                        courseDura: e.target.value,
                        chkCourseDura: false,
                      });
                    }}
                  >
                    <option value="">Select Month</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>11</option>
                    <option>12</option>
                  </select>
                  {state.chkCourseDura ? (
                    <p className="text-danger">Select Duration</p>
                  ) : null}
                </div>
                <div className="col-md-5">
                  <p className="color title"> Course Status</p>
                  <select
                    className="inp"
                    onChange={(e) => {
                      setState({
                        ...state,
                        courseStatus: e.target.value,
                        chkCourseStatus: false,
                      });
                    }}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>Open</option>
                    <option value={false}>Closed</option>
                  </select>
                  {state.chkCourseStatus ? (
                    <p className="text-danger">Select Course Status</p>
                  ) : null}
                </div>
              </div>
            </div>

            {/* <div className="col-md-5 justify-content-center py-3 mr-3 row">
              <div className="col-md-10">
                <p className="color title">Instructions</p>
                <input
                  type="text"
                  value={state.instruction}
                  className="inp"
                  placeholder="Enter Instructions"
                  onChange={(e) => {
                    setState({
                      ...state,
                      instruction: e.target.value,
                      chkInstruction: false,
                    });
                  }}
                />
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-success"
                  onClick={() => {
                    addInstructions();
                  }}
                  style={{ width: 80, height: 48, marginTop: 45 }}
                >
                  Add
                </button>
              </div>
              {state.chkInstruction ? (
                <p className="text-danger">Enter Instructions</p>
              ) : null}
            </div>
            <div className="col-md-5"></div> */}
            <div className="col-md-10">
            <p className="color title">Instructions</p>

              {/* {state.instructions.length > 0 ? (
                <p className="color title">Instructions List</p>
              ) : null} */}
              <div>
              <ContentEditable 
              html={instrucone}
              innerRef={refone}
              tagName="li"
              onChange={(e) => handleinstructionschange(e,setinstrucone)}
              />
<hr /> 

             
              <ContentEditable 
              html={instructwo}
              innerRef={reftwo}
              tagName="li"
              onChange={(e) => handleinstructionschange(e,setinstructwo)}
              />
<hr /> 

              <ContentEditable 
              html={instructhree}
              innerRef={refthree}
              tagName="li"
              onChange={(e) => handleinstructionschange(e,setinstructhree)}
              />
<hr /> 

              <ContentEditable 
              html={instrucfour}
              innerRef={reffour}
              tagName="li"
              onChange={(e) => handleinstructionschange(e,setinstrucfour)}
              />
<hr /> 

                {/* {state.instructions.map((val, ind) => {
                  return (
                    <span key={ind} className="row" style={{ marginLeft: 10 }}>
                      <li className="mr-2 mt-0" contentEditable onInput={(e) => console.log(e.target.innerHTML)}>
                         {val}
                      </li>
                      <i
                        onClick={() => {
                          state.instructions.splice(ind, 1);
                          setState({
                            ...state,
                            instructions: [...state.instructions],
                          });
                        }}
                        className="fa fa-times mr-4 mt-1 "
                        style={{
                          color: "white",
                          fontSize: 13,
                          backgroundColor: "red",
                          borderRadius: 50,
                          width: "17px",
                          height: "17px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  );
                })} */}
              </div>
            </div>
            {/* ------------- */}
          </div>
          <div className="d-flex justify-content-center mb-5">
            {!loading ? (
              <button
                className="prevbtn"
                style={{ width: 150, height: 40, marginTop: 20 }}
                onClick={() => {
                  addNewCourse();
                }}
              >
                Add Course
              </button>
            ) : (
              <div className="spinner-border load" role="status" style={{}}>
                <span className="visually-hidden"></span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCourse;
